import TweenUtils from "../utils/TweenUtils";
import Scene from "./Scene";

export default class Button extends Phaser.GameObjects.Image {
    private _callback: () => any;
    private _callbackContext: any;

    private _pointerDown = false;
    private _pointerOver = false;
    private _pointerDownAnim: () => any;

    private _clickSoundKey = "click";
    private _buttonEnabled = true;
    private _clickSoundConfig?:Phaser.Types.Sound.SoundConfig;

    private inputEnabled = false;

    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        texture: string,
        frame?: string | number,
        callback?: () => any,
        callbackContext?: any,
        bounce?: boolean
    ) {
        super(scene, x, y, texture, frame);
        this._callback = callback;
        this._callbackContext = callbackContext;
        this.enableInput();

        if(bounce){
            this.addPointerDownAnim(TweenUtils.ButtonBounce(scene, this));
        }

    }

    private enableInput(): void {
        if (!this.inputEnabled) {
            this.inputEnabled = true;
            this.setInteractive();
            this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
            this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
            this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
            this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onPointerUp, this);
        }
    }

    setCallback(callback?: () => any, callbackContext?: any): void {
        this._callback = callback;
        this._callbackContext = callbackContext;
    }

    destroy(): void {
        this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
        super.destroy();
    }

    onPointerOver(): void {
        this._pointerOver = true;
    }

    onPointerOut(): void {
        this._pointerOver = false;
    }

    onPointerDown(ptr: Phaser.Input.Pointer): void {
        this.buttonDown(ptr);
    }

    buttonDown(_ptr: Phaser.Input.Pointer): void {
        this._pointerDown = true;
        if (this._pointerDownAnim != null) this._pointerDownAnim();
    }

    onPointerUp(): void {
        this.buttonUp();
    }

    buttonUp(): void {
        if (this._pointerDown && this._pointerOver && this._buttonEnabled) {
            if (this._callback != null) this._callback.bind(this._callbackContext)();
            this.playSound();
        }
        this._pointerDown = false;
    }

    playSound(): void {
        if (this.scene && this._clickSoundKey != undefined && this._clickSoundKey != null) {
            if (this.scene instanceof Scene) this.scene.soundManager.play(this._clickSoundKey, false, this._clickSoundConfig);
            else this.scene.sound.play(this._clickSoundKey, this._clickSoundConfig);
        }
    }

    addPointerDownAnim(anim: () => any): void {
        this._pointerDownAnim = anim;
    }

    removePointerDownAnim(): void {
        this._pointerDownAnim = null;
    }

    set clickSoundKey(value: string) {
        this._clickSoundKey = value;
    }

    set buttonEnabled(value: boolean) {
        this._buttonEnabled = value;
    }

    set clickSoundConfig(value: Phaser.Types.Sound.SoundConfig) {
        this._clickSoundConfig = value;
    }
}
